import { render, staticRenderFns } from "./OtpLoginPage.vue?vue&type=template&id=28907d42"
import script from "./OtpLoginPage.vue?vue&type=script&lang=ts"
export * from "./OtpLoginPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports